import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';
import analyticsService from '../../services/analyticsService';
import { X, Cookie, Check, X as XIcon } from 'lucide-react';

const AnalyticsConsent = () => {
  const { t } = useTranslation();
  const device = useDeviceDetection();
  const [showBanner, setShowBanner] = useState(false);
  
  // Высота BottomNavigation (64px = 16 * 4)
  const bottomNavHeight = device.isMobile && device.isPortrait ? 64 : 0;

  useEffect(() => {
    const consent = localStorage.getItem('analytics_consent');
    if (consent === null) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    analyticsService.enable();
    setShowBanner(false);
  };

  const handleDecline = () => {
    analyticsService.disable();
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      data-analytics-consent-banner
      className="fixed left-0 right-0 z-50 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg" 
      style={{ 
        bottom: `${bottomNavHeight}px`,
        padding: '1rem',
        paddingBottom: `calc(1rem + env(safe-area-inset-bottom, 0))`
      }}
    >
      <div className="max-w-7xl mx-auto flex items-start gap-4">
        <div className="flex-shrink-0 mt-1">
          <Cookie className="w-6 h-6 text-blue-600 dark:text-blue-400" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            {t('analytics.consent.title', 'Мы используем аналитику')}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            {t('analytics.consent.description', 
              'Мы используем cookies и аналитику (Google Analytics и Яндекс.Метрика) для улучшения работы сайта и понимания поведения пользователей. Продолжая использовать сайт, вы соглашаетесь с этим.')}
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <button
              onClick={handleAccept}
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 dark:bg-blue-500 text-white rounded-lg hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors text-sm font-medium"
            >
              <Check className="w-4 h-4" />
              {t('analytics.consent.accept', 'Принять')}
            </button>
            <button
              onClick={handleDecline}
              className="inline-flex items-center gap-2 px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors text-sm font-medium"
            >
              <XIcon className="w-4 h-4" />
              {t('analytics.consent.decline', 'Отклонить')}
            </button>
            <Link
              to="/cookies"
              className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 underline"
              aria-label={t('analytics.consent.learnMoreCookies', 'Cookie policy and how we use cookies')}
            >
              {t('analytics.consent.learnMoreCookies', 'Cookie policy and how we use cookies')}
            </Link>
          </div>
        </div>
        <button
          onClick={() => setShowBanner(false)}
          className="flex-shrink-0 p-1 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          aria-label={t('analytics.consent.close', 'Закрыть')}
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default AnalyticsConsent;

